<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>消息</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <h6 class="content-header">客户</h6> -->
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="40px"
        >
          <el-form-item label="状态" prop="status">
            <el-select
              size="small"
              v-model="filter.status"
              placeholder="请选择"
            >
              <el-option label="所有" :value="0"></el-option>
              <el-option label="未读" :value="1"></el-option>
              <el-option label="已读" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期" prop="date">
            <el-date-picker
              v-model="filter.date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div class="mt-10">
          <el-button type="primary" size="small" @click="requestMessages()"
            >筛选</el-button
          >
          <el-button size="small" @click="reset()">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <ul v-if="messages.length > 0" class="messages">
        <li v-for="item in messages">
          <router-link class="flex-row-between" :to="item.link">
            <span class="content">
              <i :class="{ unread: item.status == 1 }"></i>
              {{ item.content }}
            </span>
            <span class="date">{{ formatTime(item.created_at) }}</span>
          </router-link>
        </li>
      </ul>
      <div v-else class="text-info-12">暂无消息</div>

      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getStore } from '@/config/storage'
import {
  createCustomer,
  customerList,
  itemCategoryList,
  itemList,
  messageList,
} from '../../service/getData'
import CustomerFormer from '@/components/customer'
import auth from '@/util/auth'
import { CodeToText } from '@/util/area_tool'
import { isMobile, messagesFormat, formatTime } from '../../util/index'
import { clone } from '@/util'

export default {
  components: {
    CustomerFormer,
  },
  data() {
    return {
      filter: {
        unread: false,
        date: null,
        size: 20,
        page: 1,
        status: 0,
      },
      formatTime,
      isMobile,
      total: 0,
      messages: [],
    }
  },
  watch: {
    'filter.page': function () {
      this.requestMessages()
    },
    'filter.unread': function () {
      if (this.filter.unread) {
        this.status = 1
      }
    },
  },
  created() {
    this.requestMessages()
  },
  methods: {
    async requestMessages() {
      let data = clone(this.filter)
      data.page = data.page - 1
      if (data.date && data.date.length == 2) {
        data.start_date = data.date[0]
        data.end_date = data.date[1]
      }
      this.loading = true
      let res = await messageList(data)
      if (res.code == 0) {
        this.messages = messagesFormat(res.data.list)
        this.total = res.data.total
      }
    },
    reset() {
      this.$refs['filterForm'].resetFields()
      this.filter.page = 1
      this.requestMessages()
    },
  },
}
</script>

<style scoped>
.messages li {
  padding: 10px 0;
  color: #555;
}

.messages li .date {
  color: #999;
  width: 100px;
  text-align: right;
}

.messages li .content {
  flex: 1;
  display: flex;
  align-items: center;
}

.messages li .content i {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 4px;
  border-radius: 4px;
  margin-top: -2px;
}

.messages li .content i.unread {
  background-color: green;
}
.messages li a {
  color: #333;
}
</style>